import React, { useState } from 'react';
import HypothesesChangesContext from './HypothesesChangesContext';

type Props = {
    children?: React.ReactNode;
};

const HypothesesChangesContextProvider = ({
    children = <></>,
}: Props): React.ReactElement => {
    const [hasChanges, setHasChanges] = useState(false);
    return (
        <HypothesesChangesContext.Provider
            value={{ hasChanges, setHasChanges }}
        >
            {children}
        </HypothesesChangesContext.Provider>
    );
};

export default HypothesesChangesContextProvider;
